import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async'; // Import Helmet
import { caseStudies } from '../data/caseStudiesData'; // Import data
import './CaseStudiesPage.css'; // We'll create this CSS file next

const CaseStudiesPage: React.FC = () => {
  return (
    <div className="case-studies-page container">
      <Helmet>
        <title>Case Studies | Proven Business Improvement Results | IntelPro</title>
        <meta name="description" content="See how IntelPro delivered results for clients in energy, retail, telecoms, and government through process optimisation, reporting, and operational launches." />
      </Helmet>
      <h1>Our Case Studies</h1>
      <p className="page-intro">
        Explore how we've helped businesses like yours overcome challenges and achieve results through tailored solutions.
      </p>
      <div className="case-studies-grid">
        {caseStudies.map((study) => {
          // Construct the fallback PNG URL assuming consistent naming
          const fallbackImageUrl = study.imageUrl.replace('.webp', '.png');

          return (
            <Link to={`/case-studies/${study.id}`} key={study.id} className="case-study-card">
              {/* Use <picture> element */}
              <picture>
                <source srcSet={study.imageUrl} type="image/webp" />
                <img
                  src={fallbackImageUrl} // Use PNG as fallback src
                  alt={study.title}
                  className="card-image"
                  loading="lazy" // Keep lazy loading for cards
                />
              </picture>
              <div className="card-content">
                <h3>{study.title}</h3>
                <div className="card-meta">
                  <span>{study.clientType}</span>
                  <span>{study.duration}</span>
                </div>
                <p className="card-excerpt">{study.situation.substring(0, 100)}...</p> {/* Short excerpt */}
                <span className="card-read-more">Read More</span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default CaseStudiesPage;